module.exports = __webpack_public_path__ + "img/pic_3_zh.140ebb35.png";